<div class="wrapper">
  <header class="dialog-header">
    <h3 class="header-heading" *ngIf="stepIndex === 0">
      {{ 'pages.user-cards.update.heading' | translate }}
    </h3>
    <h3 class="header-heading" *ngIf="stepIndex === 1">
        {{ 'pages.user-cards.update.headingCardTypesSelect' | translate }}
    </h3>
    <button class="close-button" (click)="closeDialog()"></button>
  </header>

  <div class="progress" *ngIf="steps.length > 0">
    <div
      *ngFor="let step of steps; let i = index"
      class="step-progress"
      [class.active]="stepIndex === i"
    >
      <div class="chip">{{ i + 1 }}</div>
      <h4 class="step-text">{{ step }}</h4>
    </div>
  </div>
  <div class="dialog-content">
    <form [formGroup]="form" *ngIf="!loading">
        <div class="step" *ngIf="stepIndex === 0">
            <div class="loading-spinner" *ngIf="loading">
                <mat-progress-spinner mode="indeterminate" diameter="20">
                </mat-progress-spinner>
            </div>
            <div *ngIf="isConnectorCard()" class="connector-warning">
                <span class="icon icon-warning"></span>
                {{ 'pages.user-cards.update.connectorWarning' | translate }}
            </div>
            <div class="row">
                <app-form-user-card-profile-picture class="full-width-input" label="{{'pages.user-cards.update.buttons.cardPictureButton' | translate }}" formControlName="picture" data-cy="picture">
                    <app-form-error *ngIf="picture.touched && picture.hasError('required')">
                        {{ 'pages.user-cards.update.errors.pictureRequired' | translate }}
                </app-form-error>
                </app-form-user-card-profile-picture>
            </div>
            <div class="row">
                <app-form-input class="text-input" label="{{ 'pages.user-cards.update.firstName' | translate }}" formControlName="firstName" data-cy="firstName">
                <app-form-error *ngIf="firstName.touched && firstName.hasError('required')">
                    {{ 'pages.user-cards.update.errors.invalidFirstName' | translate }}
                </app-form-error>
                </app-form-input>
                <app-form-input class="text-input" label="{{ 'pages.user-cards.update.lastName' | translate }}" formControlName="lastName" data-cy="lastName">
                <app-form-error *ngIf="lastName.touched && lastName.hasError('required')">
                    {{ 'pages.user-cards.update.errors.invalidLastName' | translate }}
                </app-form-error>
                </app-form-input>
            </div>
            <div class="row">
                <!-- <app-form-select class="text-input" label="Sex" [selected]="paymentOptions[0]" [useOptionAll]="false" placeholder="Sex" [options]="sexOptions" (selectChange)="sexChanged($event)">
                </app-form-select> -->
                <app-user-card-select class="text-input" [options]="sexOptions" controlName="sex" [form]="form" label="{{ 'pages.user-cards.update.sex' | translate }}">
                </app-user-card-select>
                <app-form-datepicker class="text-input" label="{{ 'pages.user-cards.update.birthdate' | translate }}" formControlName="birthDate" [max]="maxBirthDate" data-cy="birthDate">
                <app-form-error *ngIf="birthDate.touched && birthDate.hasError('validateDateIsInPast')">
                    {{ 'pages.user-cards.update.errors.birthDateFuture' | translate }}
                </app-form-error>
                <app-form-error *ngIf="birthDate.touched && birthDate.hasError('required')">
                    {{ 'pages.user-cards.update.errors.invalidBirthDate' | translate }}
                </app-form-error>
                </app-form-datepicker>
            </div>
            <!-- Current card address (read-only) -->
            <div class="card-address-display" *ngIf="data.card.address">
                <span class="label">{{ 'pages.user-cards.update.currentAddress' | translate }}:</span>
                <div class="card-address-value">
                    <mat-icon class="card-address-icon">credit_card</mat-icon>
                    <span>{{ data.card.address.unit ? '#' + data.card.address.unit + ' ' : '' }}{{ data.card.address.number }} {{ data.card.address.streetName || data.card.address.street }}, {{ data.card.address.city }}{{ data.card.address.province ? ', ' + data.card.address.province : '' }}, {{ data.card.address.postCode }}</span>
                </div>
            </div>
            <!-- Address selector list -->
            <div class="address-selector" *ngIf="userAddresses.length > 0">
                <span class="label">{{ 'pages.user-cards.update.address' | translate }}:</span>
                <div class="address-option"
                    *ngFor="let pa of userAddresses; let i = index"
                    [class.selected]="selectedAddressIndex === i"
                    (click)="onAddressSelected(i)">
                    <span class="address-radio">
                        <span class="radio-dot" [class.active]="selectedAddressIndex === i"></span>
                    </span>
                    <span class="address-option-text">
                        {{ pa.displayName }} &mdash;
                        {{ pa.address.unit ? '#' + pa.address.unit + ' ' : '' }}{{ pa.address.number }} {{ pa.address.streetName || pa.address.street }}, {{ pa.address.city }}
                    </span>
                    <span class="address-chips">
                        <span *ngIf="i === 0" class="address-chip address-chip--primary">
                            {{ 'pages.profile.addresses.primaryResidence' | translate }}
                        </span>
                        <span *ngIf="pa.isVerified" class="address-chip address-chip--verified">
                            {{ 'pages.profile.addresses.verified' | translate }}
                        </span>
                        <span *ngIf="!pa.isVerified" class="address-chip address-chip--unverified">
                            {{ 'pages.profile.addresses.unverified' | translate }}
                        </span>
                    </span>
                </div>
            </div>
            <!-- Fallback: geoid address search if no addresses loaded -->
            <div class="row" *ngIf="userAddresses.length === 0">
                <app-form-geoid-address
                class="full-width-input"
                label="{{ 'pages.user-cards.update.address' | translate }}"
                searchType="default"
                formControlName="address">
                </app-form-geoid-address>
            </div>
            <div class="row">
                <app-form-datepicker *ngIf="!hideExpDate" class="text-input" label="{{ 'pages.user-cards.update.expDate' | translate }}" formControlName="expDate" [min]="tomorrow" data-cy="expDate">
                    <app-form-error *ngIf="expDate.touched && expDate.hasError('required')">
                        {{ 'pages.user-cards.update.errors.expDateRequired' | translate }}
                    </app-form-error>
                </app-form-datepicker>
                <div class="text-input subtype-wrapper" *ngIf="subTypes.length > 1" [class.subtype-locked]="subTypeLocked">
                    <app-user-card-select [options]="subTypes" controlName="subType" [form]="form"
                    label="{{ 'pages.user-cards.update.subtype' | translate }}">
                    </app-user-card-select>
                    <span class="subtype-lock-hint" *ngIf="subTypeLocked">
                        <i class="icon-lock"></i>
                    </span>
                </div>
            </div>
        </div>
    
        <div class="step" *ngIf="stepIndex === 1">
            <div class="card-types-box"
                formArrayName="cardTypes"
                *ngFor="let selectableCard of form.value.cardTypes; let i = index; trackBy: trackByCardType"
            >
                <app-form-checkbox [formControlName]="i" [showMessages]="false" [disabled]="cardTypes[i].cardType == cardType"></app-form-checkbox>
                <span [ngClass]="getCardButtonIcon(cardTypes[i].cardType)"></span>
                <span class="selectableCard">
                    {{cardTypes[i].label}}
                </span>
            </div>
        </div>
    </form>
  </div>

  <footer class="dialog-footer">
    <button
        *ngIf="stepIndex > 0"
        (click)="back()"
        class="bciti-inline-button back-button"
    >
        {{ 'pages.user-cards.common.button.back' | translate }}
    </button>
    <div class="spacer"></div>
    <button *ngIf="stepIndex === 0 && cardTypes.length > 1"
        (click)="next()" 
        class="bciti-button bciti-button--blue">
        {{ 'pages.user-cards.common.button.next' | translate }}
    </button>

    <button *ngIf="stepIndex === 1 || cardTypes.length <= 1" 
        [disabled]="processingSubmit || !form.valid" 
        (click)="submit()" 
        class="bciti-button" 
        [ngClass]="form.valid ? 'bciti-button--blue' : 'bciti-button--disabled'">
        <span *ngIf="!processingSubmit">{{ 'pages.user-cards.update.buttons.save' | translate }}</span>
        <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
      </button>
  </footer>
</div>